import { FileType, ImageType } from "@/types/baseTypes";
import styles from "./MediaInfo.module.scss";
import { useModal } from "../_primitives/Modal/ModalRoot/ModalRoot";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

interface MediaInfoModalContentProps {
  media: React.ReactNode;
  video?: FileType;
  image_desktop?: ImageType;
  image_fullhd?: ImageType;
  image_tablet?: ImageType;
  image_mobile?: ImageType;
  copyrightJSX: (JSX.Element | undefined)[];
  hasVideoDescription: boolean;
  hasMobileDescription: boolean;
  hasTabletDescription: boolean;
  hasDesktopDescription: boolean;
  hasFullhdDescription: boolean;
}

const MediaInfoModalContent = ({
  media,
  video,
  image_desktop,
  image_fullhd,
  image_tablet,
  image_mobile,
  copyrightJSX,
  hasVideoDescription,
  hasMobileDescription,
  hasTabletDescription,
  hasDesktopDescription,
  hasFullhdDescription,
}: MediaInfoModalContentProps) => {
  const { setOpen } = useModal();
  const { getLabel } = useGlobalContext();
  let aspectRatio;
  if (image_desktop && image_desktop.mime_type?.includes("svg")) {
    aspectRatio =
      (image_desktop.width / image_desktop.height).toFixed(4) + " / 1";
  }

  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div
      className={`section w-100 ${styles["media-info-modal-section"]}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setOpen(false);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          setOpen(false);
        }
      }}
    >
      <div className="container">
        <div className={`${styles["media-info"]}`}>
          <div className={`${styles["media-info-media"]}`}>
            <div
              className={styles["media-info-image-container"]}
              data-aspect-ratio={!!aspectRatio}
              style={
                {
                  ...(aspectRatio && { "--aspect-ratio": aspectRatio }),
                } as React.CSSProperties
              }
            >
              {media}
            </div>
          </div>

          <div className={`${styles["media-info-text"]}`}>
            {(hasVideoDescription ||
              hasMobileDescription ||
              hasTabletDescription ||
              hasDesktopDescription ||
              hasFullhdDescription) && (
              <div
                className={`${styles["media-info-text-scroll-container"]}`}
                data-lenis-prevent
              >
                <p className={`caption pb-2 ${styles["media-info-title"]}`}>
                  {getLabel("media_description", "Beschreibung")}
                </p>
                {hasVideoDescription && <p>{video?.description}</p>}
                {hasMobileDescription && (
                  <p className={`caption pb-0 is-hidden-tablet`}>
                    {image_mobile?.description}
                  </p>
                )}
                {hasTabletDescription && (
                  <p
                    className={`caption pb-0 is-hidden-mobile is-hidden-desktop`}
                  >
                    {image_tablet?.description}
                  </p>
                )}
                {hasDesktopDescription && (
                  <p
                    className={`caption pb-0 ${hasMobileDescription ? "is-hidden-mobile" : ""} ${hasTabletDescription ? "is-hidden-tablet-only" : ""} ${hasFullhdDescription ? "is-hidden-fullhd" : ""}`}
                  >
                    {image_desktop?.description}
                  </p>
                )}
                {hasFullhdDescription && (
                  <p
                    className={`caption pb-0 is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only`}
                  >
                    {image_fullhd?.description}
                  </p>
                )}
              </div>
            )}
            {copyrightJSX.length > 0 && (
              <div>
                <p className={`caption pb-2 ${styles["media-info-title"]}`}>
                  Copyright
                </p>
                <div className={`${styles.copyright} copyright has-text-left`}>
                  {copyrightJSX}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaInfoModalContent;
